module.exports = __webpack_public_path__ + "static/media/class2.7d3081b8.jpg";